// Grouped is excluded as it could contain marketplaces which are
export const NonDispatchableMarketplaces = ['csv', 'manual'];
